import { render, staticRenderFns } from "./bananRanking.vue?vue&type=template&id=346f2066&scoped=true&"
import script from "./bananRanking.vue?vue&type=script&lang=ts&"
export * from "./bananRanking.vue?vue&type=script&lang=ts&"
import style0 from "./bananRanking.vue?vue&type=style&index=0&id=346f2066&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346f2066",
  null
  
)

export default component.exports